
  import { Component, Vue, Watch } from 'vue-property-decorator';
  import debounce from 'lodash/debounce';
  import {
    Client,
    IJobModel,
    JobModel,
    IJobItemModel,
    JobItemModel,
    IJobNoteModel,
    JobNoteModel,
    UserModel
  } from '@/services/api.service';
  import { JobItemType, JobType, JobTypeEnums, JobItemTypeEnums } from '@/common/enumerations';
  import { JobNoteUpdatedMessage } from '@/services/eventbus.models';
  import { EventBus } from '@/event-bus';
  import * as DateUtils from '@/utilities/date.utils';

  import toJobItemTypeFormatter from '@/filters/jobitemtype.formatter';
  import toDateFormatter from '@/filters/todate.formatter';
  import toLeastDateUTCFormatter from '@/filters/toleastdate.formatter';

  @Component({
    props: {
      jobNote: {
        type: Object as () => IJobNoteModel,
        required: false
      },
      jobGid: String
    },
    filters: {
      toJobItemType: toJobItemTypeFormatter,
      toDate: toDateFormatter,
      toLeastDate: toLeastDateUTCFormatter
    }
  })
  export default class JobNoteCard extends Vue {
    protected created() {
      EventBus.$on('job-note-updated', (message: JobNoteUpdatedMessage) => {
        this.handleJobNoteUpdatedEvent(message);
      });
    }

    protected mounted() {
      // get the networks
      // Object.assign(this.data, this.$props.jobItem);
      // console.log('JobItemCard:localdatamodel');
      // console.log(this.data);
    }
    protected beforeDestroy() {
      EventBus.$off('job-note-updated');
    }

    @Watch('jobNote', { immediate: false, deep: true })
    private onjobNoteChanged(oldValue: IJobNoteModel, newValue: IJobNoteModel) {
      console.log('watched job note changed:');
      console.log(oldValue);
      console.log(newValue);
    }

    private handleJobNoteUpdatedEvent(message: JobNoteUpdatedMessage) {
      // console.log('EVENTBUS: received job-note-updated message');
      // console.log(message);
      if (message.data !== null) {
        if (message.data.gid === this.$props.jobNote.gid) {
          // Just update the status for the moment. The rest
          // of the property changes are pushed in via the
          // $props.jobItem
        }
      }
    }

    private editJobNote() {
      this.$emit('on-edit-jobnote', this.$props.jobNote);
    }

    private deleteJobNote() {
      this.$emit('on-delete-jobnote', this.$props.jobNote);
    }
  }
